import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios'
import URL from '@/_url_'
import qs from 'qs'
import createPersistedState from "vuex-persistedstate"

// 模块导入
import user from './modules/user' // 用户模块
import banner from './modules/banner' // 广告模块
import goods from './modules/goods' // 商品模块
import instructions from './modules/instructions' // 产品试用模块
import other from './modules/other' // 其它模块
import order from './modules/order' // 订单模块
import call from './modules/callCenter' // 支援中心

Vue.use(Vuex)

let lang= localStorage.lang;

export default new Vuex.Store({
	state: {
		// 公用参数
		loading: false, // 加载动画
		dialogVisible: false, // 模态框
		dialogFalse:false,
		innerDialogVisible: false, // 内层模态框
		currency:"", // 货币单位
		show_price: Boolean, // 价格是否显示
	},
	mutations: {
		handleLoading(state, arg){ // 更改加载动画状态
			state.loading = arg
		},
		handleDialog(state, arg){ // 更改模态框状态
		// console.log("恭喜发财2",arg)
			state.dialogVisible = arg;
			
		},
		handleFalse(state, arg){ // 更改模态框状态
			// console.log("恭喜发财1",arg)
			state.dialogFalse = arg;
			
			
		},
		handleInnerDialog(state, arg){ // 更改内层模态框状态
			state.innerDialogVisible = arg;
			
		},
		setCurrency(state, arg){ // 写入货币单位
			state.currency = arg;
		},
		setPriceDisplay(state, arg){ // 写入货币单位
			state.show_price = arg;
		},
	},
	actions: {
		getCurrency(context){ // 价格单位获取
            let url="/index/header/currency?lang="+lang;
            axios.get(url).then((res)=>{
                if(res.data.code==1){
                    context.commit("setCurrency",res.data.unit.currency)
                }
            }).catch(()=>{})
		},
		getTitle( { commit }, arg){ // 获取页面title
			let url = "index/index/title?lang=" + lang + "&title=" + arg;
			return new Promise((reslove) => {
				axios.get(url).then( res => {
					if(res.data.code == 1){
						reslove(res.data.title)
					}
				}).catch(() => {})
			})
		},
		getPriceDisplay({commit}){ // 获取价格是否显示
			let url = "/index/header/price_display";
			axios.get(url).then(res => {
				if(res.data.code == 1){
					commit("setPriceDisplay", res.data.price_display == 1);
				}
			}).catch(() => {})
		}
	},
	modules: {
		user,
		banner,
		goods,
		instructions,
		other,
		order,
		call
	},
	plugins: [createPersistedState({
		storage: {
			getItem: key => sessionStorage.getItem(key),
			setItem: (key, value) => sessionStorage.setItem(key, value),
			removeItem: key => sessionStorage.removeItem(key)
		},
		paths: [ "user.company", "user.islogin", "user.user_info", "user.power", "user.character_id", "order.cart_order" ],
	})]
})
